<template>
  <div>
    <button class="btn btn-green" @click="showModal">+ New fleet</button>

    <!-- Modal -->
    <div class="modal fade" ref="fleetModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">New fleet</h4>
            <button type="button" class="close" @click="hideModal" aria-label="Close">
              <span aria-hidden="true">X</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row d-flex align-items-stretch">
              <!-- Contract details Card -->
              <div class="col-md-6 d-flex">
                <div class="card flex-grow-1">
                  <div class="card-body">
                    <div class="form-group">
                      <h5 class="section-title">Contract details</h5>
                      <label for="first-name">Fleet ID</label>
                      <input type="text" id="fleet-id" class="form-control" v-model="form.fleet_id" />
                      <span v-if="errors.fleet_id" class="text-danger">{{ errors.fleet_id }}</span>
                    </div>
                    <div class="form-group">
                      <label for="last-name">Fleet name</label>
                      <input type="text" id="fleet-name" class="form-control" v-model="form.fleet_name" />
                      <span v-if="errors.fleet_name" class="text-danger">{{ errors.fleet_name }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Access Card -->
              <div class="col-md-6 d-flex">
                <div class="card flex-grow-1">
                  <div class="card-body">
                    <div class="form-group">
                      <div class="row">
                        <div class="col-md-6 col-12">
                          <span>Created:</span>
                        </div>
                        <div class="col-md-6 col-12">
                          <span>Last updated:</span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group mt-4">
                      <div class="col-12 mt-2 checkbox checkbox-success">
                        <input id="accessEnabled" type="checkbox" v-model="form.enabled">
                        <label for="accessEnabled">Enabled</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end">
                <button class="btn btn-green btn-ok me-1" @click="submitForm">OK</button>
                <button class="btn btn-cancel" @click="hideModal">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { Modal } from 'bootstrap';
import { useFleetStore } from '@/store/admin/fleet';

const fleetStore = useFleetStore();

// 表單的初始狀態
const form = ref({
  fleet_id: '',
  fleet_name: '',
  enabled: false,
});

const errors = ref({
  fleet_id: '',
  fleet_name: '',
});

const fleetModal = ref(null);
let modalInstance = null;

const showModal = () => {
  if (!modalInstance) {
    modalInstance = new Modal(fleetModal.value);
  }
  modalInstance.show();
};

const hideModal = () => {
  if (modalInstance) {
    modalInstance.hide();
  }
};

const validateForm = () => {
  let valid = true;

  // 驗證每個欄位
  if (!form.value.fleet_id) {
    errors.value.fleet_id = 'Fleet ID is required';
    valid = false;
  } else {
    errors.value.fleet_id = '';
  }

  if (!form.value.fleet_name) {
    errors.value.fleet_name = 'Fleet name is required';
    valid = false;
  } else {
    errors.value.fleet_name = '';
  }

  return valid;
};

const submitForm = () => {
  if (!validateForm()) {
    return;
  }

  // 準備資料
  const payload = {
    fleet_id: form.value.fleet_id,
    name: form.value.fleet_name,
    enabled: form.value.enabled ? 1 : 0, // 轉換為 '1' 或 '0'
  };

  fleetStore.createFleet(payload)
    .then(() => {
      hideModal();
      // 初始化表單
      form.value = {
        fleet_id: '',
        fleet_name: '',
        enabled: false,
      };
    })
    .catch(error => {
      console.error('Error creating member:', error);
    });
};
</script>

<style scoped>
label {
  font-size: 16px;
  margin-top: 5px;
}

.btn-green {
  background: rgba(0, 201, 98, 1);
  color: black;
  border: none;
  width: 244.83px;
  height: 46px;
  border-radius: 30px;
  padding: 10px, 32px, 10px, 32px;
}

.btn-green:hover {
  background-color: #00b452;
}

.btn-ok {
  width: 150px;
}

.btn-cancel {
  background-color: #fff;
  color: #8476f4;
  border: 2px solid #8476f4;
  border-radius: 30px;
  width: 150px;
  height: 46px;
  padding: 14px 32px 14px 32px;
}

.btn-cancel:hover {
  background-color: #e6e6ff;
}

.modal-content {
  border-radius: 10px;
  padding: 20px;
}

.modal-header {
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-header {
  border-bottom: 1px solid #dee2e6;
  font-weight: bold;
  background-color: #d9dde3;
}

.card {
  background-color: #d9dde3;
}

.close {
  color: #333;
  opacity: 1;
  font-size: 20px;
  padding: 0;
  background: none;
  border: none;
}

.close:hover {
  color: #000;
}

/* 使用 flexbox 來讓卡片等高 */
.row.d-flex {
  display: flex;
}

.col-md-6.d-flex {
  display: flex;
  flex-direction: column;
}

.card.flex-grow-1 {
  flex-grow: 1;
}

.align-items-stretch {
  align-items: stretch;
}

.text-danger {
  color: red;
  font-size: 0.9em;
}
</style>
